import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {IoCarSportSharp, IoPower} from "react-icons/io5";
import MapMarker from "../../Assets/Images/marker-icon.png"
import {MapContainer, Marker, TileLayer, Popup} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import BG from "../../Assets/Images/splash.jpg"
import Balad from "../../Assets/Images/balad.png"

import Gmap from "../../Assets/Images/gmap.png"


import {FaCarBattery, FaRoute, FaSatellite, FaSimCard} from "react-icons/fa";
import {BiEdit, BiMapAlt} from "react-icons/bi";
import {
    MdCalendarMonth,
    MdPhoneIphone,
    MdWifiTethering,
    MdWifiTetheringError
} from "react-icons/md";
import {BsSpeedometer2} from "react-icons/bs";
import {IoMdClock, IoMdMap} from "react-icons/io";
import {TbCircuitChangeover, TbReportSearch} from "react-icons/tb";
import {GiBattery75, GiCarDoor, GiRotaryPhone} from "react-icons/gi";

import {VscSignOut} from "react-icons/vsc";

import {SlMinus, SlPlus} from "react-icons/sl";
import {HiStatusOnline} from "react-icons/hi";
import {useSearchParams} from "react-router-dom";

var intervalID = 0;

let DefaultIcon = L.icon({
    iconUrl: MapMarker,
    iconSize: [32, 32],
});

L.Marker.prototype.options.icon = DefaultIcon;

const center = [36.32, 59.51]
const zoom = 11

const satellite = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
const normal = 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'

const currencyFormat = Intl.NumberFormat('en-US');

function Home() {
    const [searchParams, setSearchParams] = useSearchParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [vehicles, setVehicles] = React.useState([]);
    const [map, setMap] = React.useState(null);
    const [showInfo, setShowInfo] = React.useState(0);
    const [editCar, setEditCar] = React.useState(0);
    const [carName, setCarName] = React.useState('');
    const [deleteCar, setDeleteCar] = React.useState(0);
    const [activeCar, setActiveCar] = React.useState(0);
    const [activeCarIndex, setActiveCarIndex] = React.useState(0);
    const [showVehicles, setShowVehicles] = React.useState(0);

    const [routeLat, setRouteLat] = React.useState(0);
    const [routeLng, setRouteLng] = React.useState(0);
    const [showRouteMap, setShowRouteMap] = React.useState(false);


    const updateVehicle = () => {
        setIsLoaded(false);
        const request = {
            title: carName,
            id: editCar,
        }
        API.updateVehicles(request, editCar)
            .then((response) => {
                setIsLoaded(true);
                toast.success(response.message);
                setEditCar(0);
                setCarName('')
                setDeleteCar(0)
                loadVehicles()
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    const deleteVehicle = () => {
        API.deleteVehicles(editCar)
            .then((response) => {
                setIsLoaded(true);
                toast.success(response.message);
                setEditCar(0);
                setCarName('')
                setDeleteCar(0)
                loadVehicles()
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    const loadVehicles = () => {
        API.getVehicles()
            .then((response) => {
                setVehicles(response.data);
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }

    const onExitClick = () => {
        window.location.assign("https://r.telcarnet.com/")
       /* localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")*/
    }

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }


        const message = searchParams.get('message')
        const success = searchParams.get('success')

        if(message?.length > 3) {
            if(success > 0) {
                toast.success(message)
            }
            else{
                toast.error(message)
            }
        }


        const drawLine = (pointA, pointB, color) => {
            let line = new L.Polyline([pointA, pointB], {
                color: color,
                weight: 3,
                opacity: 1,
                smoothFactor: 1
            });
            line.addTo(map);
        }

        if (map) {
            API.getVehicles()
                .then((response) => {
                    setIsLoaded(true);
                    setVehicles(response.data);



                    response.data.forEach((vehicle) => {
                        if (vehicle.points[0]) {

                            const pointA = new L.LatLng(vehicle.points[0]?.lat, vehicle.points[0]?.long);
                            const pointB = new L.LatLng(vehicle.points[1]?.lat, vehicle.points[1]?.long);
                            drawLine(pointA, pointB, 'blue')

                            setInterval(() => {
                                const request = {
                                    mobile: vehicle.tracking_device_data.main_phone,
                                };

                                API.socketSendData(request)
                                    .then((response) => {

                                    })
                            }, 100000)

                        }
                    })

                    if (response.data[0].points[0])
                        map.panTo(new L.LatLng(response.data[0]?.points[0]?.lat, response.data[0]?.points[0]?.long));


                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });

            setTimeout(() => {
                loadData();

            }, 5000)

        }


    }, [map]);

    const drawLine = (pointA, pointB, color) => {
        let line = new L.Polyline([pointA, pointB], {
            color: color,
            weight: 3,
            opacity: 1,
            smoothFactor: 1
        });
        line.addTo(map);
    }
    const loadData = (vehicleIndex = 0) => {

        intervalID = setInterval(() => {

            API.getVehicles()
                .then((response) => {

                    setIsLoaded(true);
                    setVehicles(response.data);
                    response.data.forEach((vehicle) => {
                        if (vehicle.points[0]) {
                            const pointA = new L.LatLng(vehicle.points[0]?.lat, vehicle.points[0]?.long);
                            const pointB = new L.LatLng(vehicle.points[1]?.lat, vehicle.points[1]?.long);
                            drawLine(pointA, pointB, 'blue')
                        }
                    })
                    if (response.data[vehicleIndex]?.points[0])
                        map.panTo(new L.LatLng(response.data[vehicleIndex]?.points[0]?.lat, response.data[vehicleIndex]?.points[0]?.long));

                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }, 5000)
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            {
                showRouteMap &&

                <section className='container-fluid' id='map-app-selector'>
                    <div className="row">
                        <div className="col-12">
                            <div className="row map-app-cart">
                                <div className="col-12">
                                  {/*  <Logo size={120}/>*/}
                                </div>
                         {/*       <div className="col-12 mt-5">
                                    <button className="btn btn-dark w-100 small"
                                            onClick={() => {
                                                setShowRouteMap(false)
                                                window.open(`https://maps.neshan.org/@${routeLat},${routeLng},14.5z,0.0p/routing/car/`)
                                            }}
                                    >
                                        <img src={Nehan} alt="neshan" width='32' className='float-right'/>
                                        مسیریابی با نقشه نشان
                                    </button>
                                </div>*/}
                                <div className="col-12 mt-3">

                                    <button className="btn btn-dark w-100 small"
                                            onClick={() => {
                                                setShowRouteMap(false)
                                                window.open("http://maps.google.com/maps?saddr=&daddr=" + routeLat + "," + routeLng)
                                            }}
                                    >
                                        <img src={Gmap} alt="Google Map" width='32' className='float-right'/>
                                        مسیریابی با نقشه گوگل
                                    </button>
                                </div>
                                <div className="col-12 mt-3">

                                    <button className="btn btn-dark w-100"
                                            onClick={() => {
                                                setShowRouteMap(false)
                                                window.open(`geo:${routeLat},${routeLng}`)
                                            }}
                                    >
                                        <img src={Balad} alt="Balad" width='32' className='float-right'/>
                                        مسیریابی با دیگر مسیریاب ها
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            }
            <section className="container-fluid  overflow-hidden  pb-5 rtl px-0   "
                     style={{backgroundImage: `url('${BG}')`}}>
                <div className="row ">
                    <div className="col-12 ">
                        <nav className="navbar navbar-light bg-white mb-4 p-0 m-0 actionbar  py-2">
                             <span className='mx-3 sign-out' onClick={onExitClick}>
                                <VscSignOut className='mx-1 text-big-2'/>
                                بازگشت به ریموت
                            </span>
                            <a className="navbar-brand mx-4" href="#">
                               {/* <img src={LogoPic} alt="TelCarNet" className="rounded " width="30"/>*/}
                            </a>

                        </nav>
                    </div>
                </div>
                <div className="row mx-2 mb-3">

                    <div className="col-md-3">
                        <div className=" text-center text-small-2 pt-2 pb-1   alert alert-secondary"

                        >
                           <div
                               onClick={() => {setShowVehicles(1 - showVehicles)}}
                           >
                               لیست خودروها
                               {
                                   showVehicles > 0 ?
                                       <span  className='text-big-5 text-primary float-start' >
                              <SlMinus />
                            </span>
                                       :
                                       <span  className='text-big-5 text-success float-start' >
                              <SlPlus/>
                            </span>
                               }
                               <div className='mt-4 text-small-2 fw-bold text-primary border-bottom'>
                                   <div className="row bg-light p-2 rounded">
                                       <div className="col-6 text-end">
                                           خودروی فعال:

                                           &nbsp;
                                           {
                                               isLoaded && vehicles[activeCarIndex].title
                                           }
                                       </div>
                                       <div className="col-6 text-start text-dark"

                                       >
                                           <FaRoute className='mx-2'/>
                                           {
                                               vehicles[activeCarIndex]?.remaining_days > 0 ?

                                           <span

                                               onClick={() => {
                                                   window.localStorage.setItem("CarName", vehicles[activeCarIndex].title);
                                                   window.location.assign(`/tracking-history/${vehicles[activeCarIndex].id}`)
                                               }}
                                           >مرور مسیر

                                           </span> :
                                               <span className='text-danger' role='button'
                                               onClick={() => {
                                                   window.location.assign(`/subscription/${vehicles[activeCarIndex].id}`)
                                               }}
                                               >
                                               شارژ پنل
                                               </span>
                                           }
                                       </div>
                                   </div>

                               </div>
                           </div>

                            <div className={showVehicles ? 'show-cars mt-4' : 'hide-cars'}

                            >
                                {
                                    vehicles.map((vehicle, index) => {

                                        if (editCar === vehicle.id)
                                            return (
                                                <div

                                                    className="row vehicle-list py-2  border-bottom vehicle-row  "

                                                    key={vehicle.id}


                                                >

                                                    <div className="col-12 text-small-2 pt-1  pe-1   fw-bold cursor-pointer">

                                                        <div className="input-group mb-3 ">

                                                            <input type="text" className="form-control text-small-1"
                                                                   placeholder="نام خودرو"
                                                                   value={carName}
                                                                   onChange={(val) => {
                                                                       setCarName(val.target.value)
                                                                   }}
                                                                   aria-label="Username" aria-describedby="basic-addon1"/>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 pb-2 text-small-1 border-bottom">
                                                        <div className="form-check text-danger">
                                                            <input type="checkbox" className="form-check-input"
                                                                   id="exampleCheck1"
                                                                   onClick={(val) => {
                                                                       setDeleteCar(1 - deleteCar)

                                                                   }
                                                                   }
                                                            />
                                                            <label className="form-check-label text-small-1 "
                                                                   htmlFor="exampleCheck1">
                                                                حذف خودرو
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-8 py-2 ">
                                                        <button type="button"
                                                                className={deleteCar === 1 ? 'btn text-small-3 btn-danger w-100 ' : 'btn text-small-3 btn-success w-100 '}
                                                                data-toggle="button"
                                                                aria-pressed="false"
                                                                onClick={deleteCar ? deleteVehicle : updateVehicle}
                                                        >
                                                            {deleteCar === 1 ? 'حذف خودرو' : 'ویرایش نام خودرو'}
                                                        </button>
                                                    </div>
                                                    <div className="col-4 py-2 ">
                                                        <button type="button" className="btn text-small-3 btn-secondary w-100"
                                                                data-toggle="button"
                                                                aria-pressed="false"
                                                                onClick={() => {
                                                                    setCarName('')
                                                                    setEditCar(0)
                                                                }
                                                                }
                                                        >
                                                            انصراف
                                                        </button>
                                                    </div>
                                                </div>
                                            )
                                        return (

                                            <div
                                                className={activeCar === vehicle.id ? "row vehicle-list py-2 px-2 border-bottom vehicle-row vehicle-active " :
                                                    "row vehicle-list py-2 px-2 border-bottom vehicle-row  "}
                                                key={vehicle.id}
                                                onClick={
                                                    () => {
                                                        // setActiveCarInfo(vehicles[index])
                                                        if (vehicle.points[0]) {
                                                            clearInterval(intervalID);
                                                            map.panTo(new L.LatLng(vehicle.points[0]?.lat, vehicle.points[0]?.long));

                                                            setActiveCar(vehicle.id)
                                                            setActiveCar(index)
                                                            setActiveCarIndex(index)
                                                            setShowVehicles(0)

                                                            setTimeout(() => {
                                                                loadData(index);
                                                                map.setZoom(15)
                                                            }, 500)
                                                        } else {
                                                            toast.warn('اطلاعات موقعیتی خودرو موجود نیست')
                                                        }


                                                    }
                                                }

                                            >
                                                <div className="col-2 pe-4 border-bottom">
                                                    {vehicle.tracking_device_data.is_conneted_gps > 0 ?
                                                        <MdWifiTethering className='text-dark'
                                                                         title=' جی پی اس دستگاه متصل است'/>
                                                        :
                                                        <MdWifiTetheringError className='text-danger'
                                                                              title='جی پی اس دستگاه متصل نیست'/>
                                                    }

                                                </div>
                                                <div
                                                    className="col-10 text-small-2 pt-1 text-wa  pe-1 pb-3 border-bottom fw-bold cursor-pointer">
                                                    {vehicle.title}
                                                    <span className='mx-2 edit-car'
                                                          onClick={() => {

                                                              setCarName(vehicle.title)
                                                              setEditCar(vehicle.id)
                                                              setDeleteCar(0)
                                                              setIsLoaded(false)
                                                              setTimeout(() => {
                                                                  setShowVehicles(1)
                                                                  setIsLoaded(true)
                                                              }, 400)
                                                          }
                                                          }
                                                    >
                                                <BiEdit className='text-big-3'/>
                                            </span>

                                                    <span
                                                        className='badge badge-pill badge-dark bg-dark mx-2 text-small-2 float-start mt-1'>
                                                {vehicle.tracking_device_model}
                                            </span>
                                                </div>

                                                <div className="col-6 text-small-3 pt-2 text-dark cursor-pointer"

                                                >
                                                    <FaRoute className='mx-2'/>
                                                    {
                                                        vehicle.remaining_days > 0 ?

                                                            <span

                                                                onClick={() => {
                                                                    window.localStorage.setItem("CarName", vehicle.title);
                                                                    window.location.assign(`/tracking-history/${vehicle.id}`)
                                                                }}
                                                            >مرور مسیرها</span> :
                                                            <span className='text-danger'
                                                                  role='button'
                                                                  onClick={() => {
                                                                      window.location.assign(`/subscription/${vehicle.id}`)
                                                                  }}
                                                            >
                                               شارژ پنل
                                               </span>
                                                    }

                                                </div>

                                                <div className="col-6 text-small-3 pt-2 text-dark text-start
                                        cursor-pointer
                                        "

                                                >
                                                    <TbReportSearch className='mx-2'/>
                                                    <span
                                                        onClick={() => {
                                                            setShowInfo(showInfo === vehicle.id ? 0 : vehicle.id)
                                                            setIsLoaded(false)
                                                            setTimeout(() => {
                                                                setShowVehicles(showInfo === vehicle.id ? 0 : 1)
                                                                setIsLoaded(true)
                                                            }, 500)
                                                        }}
                                                    >مشاهده اطلاعات</span>
                                                </div>

                                                {
                                                    showInfo === vehicle.id ?
                                                        <div className="col-12 mt-3 ">
                                                            <div className="row info-card pb-3 ">
                                                                <div
                                                                    className="col-12 text-center alert alert-dark  mb-3 py-1 ">
                                                                    {
                                                                        vehicle.date
                                                                    }
                                                                </div>
                                                                <div className="col-1 ">
                                                                    <FaSimCard/>
                                                                </div>
                                                                <div className="col-6">
                                                                    شارژ سیمکارت
                                                                </div>
                                                                <div className="col-5 text-start fw-bold">
                                                                    {currencyFormat.format(vehicle.tracking_device_data.sharj)}
                                                                    &nbsp;
                                                                    ریال
                                                                </div>


                                                                <div className="col-1 mt-3">
                                                                    <GiBattery75/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                    شارژ باتری
                                                                </div>
                                                                <div className="col-5 mt-3 text-start fw-bold">
                                                                    {vehicle.tracking_device_data.battery_sharj}
                                                                    &nbsp;
                                                                    درصد
                                                                </div>


                                                                <div className="col-1 mt-3">
                                                                    <FaCarBattery/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                    وضعیت باتری
                                                                </div>
                                                                <div className="col-5 mt-3 text-start fw-bold">
                                                                    {vehicle.tracking_device_data.is_battery_connected > 0 ?
                                                                        'متصل' : 'قطع'
                                                                    }
                                                                </div>


                                                                <div className="col-1 mt-3">
                                                                    <GiCarDoor/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                    وضعیت درها
                                                                </div>
                                                                <div className="col-5 mt-3 text-start fw-bold">
                                                                    {vehicle.tracking_device_data.door > 0 ?
                                                                        'باز' : 'بسته'
                                                                    }
                                                                </div>


                                                                <div className="col-1 mt-3">
                                                                    <TbCircuitChangeover/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                    وضعیت رله
                                                                </div>
                                                                <div className="col-5 mt-3 text-start fw-bold">
                                                                    {vehicle.tracking_device_data.rele > 0 ?
                                                                        'وصل' : 'قطع'
                                                                    }
                                                                </div>


                                                                <div className="col-1 mt-3">
                                                                    <GiRotaryPhone/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                    شماره تلفن اصلی
                                                                </div>
                                                                <div className="col-5 mt-3 text-start fw-bold">
                                                                    {vehicle.tracking_device_data.main_phone}
                                                                </div>


                                                                <div className="col-1 mt-3">
                                                                    <MdPhoneIphone/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                    شماره موبایل نخست
                                                                </div>
                                                                <div className="col-5 mt-3 text-start fw-bold">
                                                                    {vehicle.tracking_device_data.phone1}
                                                                </div>


                                                                <div className="col-1 mt-3">
                                                                    <MdPhoneIphone/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                    شماره موبایل دوم
                                                                </div>
                                                                <div className="col-5 mt-3 text-start fw-bold">
                                                                    {vehicle.tracking_device_data.phone2}
                                                                </div>


                                                                <div className="col-1 mt-3">
                                                                    <MdPhoneIphone/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                    شماره موبایل سوم
                                                                </div>
                                                                <div className="col-5 mt-3 text-start fw-bold">
                                                                    {vehicle.tracking_device_data.phone3}
                                                                </div>


                                                                <div className="col-1 mt-3">
                                                                    <MdPhoneIphone/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                    شماره موبایل چهارم
                                                                </div>
                                                                <div className="col-5 mt-3 text-start fw-bold">
                                                                    {vehicle.tracking_device_data.phone4}
                                                                </div>
                                                                <div className="col-1 mt-3">
                                                                    <MdCalendarMonth/>
                                                                </div>
                                                                <div className="col-6 mt-3">
                                                                   تاریخ پایان
                                                                </div>
                                                                <div className={vehicle.remaining_days > 0 ?"col-5 mt-3 text-start fw-bold text-success" : "col-5 mt-3 text-start fw-bold text-danger"}>
                                                                    {vehicle.warranty_date}
                                                                </div>

                                                            </div>
                                                        </div>
                                                        :
                                                        ''
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>



                    </div>
                    <div className="col-md-9 ">
                        <div className=" maps-container ">
                            <div className='map-part'>
                                <div
                                    className='satellite-btn'
                                    onClick={
                                        () => {

                                            L.tileLayer(satellite, {}).addTo(map);
                                        }
                                    }
                                >
                                    <FaSatellite className='ms-2'/>
                                    ماهواره ای
                                </div>
                                <div
                                    className='normal-btn'
                                    onClick={
                                        () => {

                                            L.tileLayer(normal, {}).addTo(map);
                                        }
                                    }
                                >
                                    <BiMapAlt className='ms-2'/>
                                    نقشه پیش فرض
                                </div>
                                <MapContainer
                                    center={center}
                                    zoom={zoom}
                                    scrollWheelZoom={true}
                                    className='w-100'
                                    ref={setMap}

                                >
                                    {
                                        isLoaded && vehicles.map(vehicle => {
                                            if (vehicle?.points[0]) {
                                                return (

                                                    <Marker
                                                        position={[vehicle?.points[0]?.lat, vehicle?.points[0]?.long]}
                                                        key={vehicle.id}

                                                    >
                                                        <Popup>
                                                            <div
                                                                className='badge badge-pill badge-dark bg-dark mx-2 text-small-2  mt-1 w-100'>
                                                                <IoCarSportSharp className='ms-2 float-end'/>
                                                                {vehicle.title}
                                                            </div>
                                                            <div
                                                                className='badge badge-pill badge-dark bg-secondary mt-2 mx-2 text-small-2  mt-1 w-100'>
                                                                <BsSpeedometer2 className='ms-2 float-end'/>
                                                                {
                                                                    vehicle.points[0]?.speed
                                                                }
                                                                &nbsp;
                                                                کیلومتر
                                                            </div>
                                                            <div
                                                                className='badge badge-pill badge-dark bg-secondary mt-2 mx-2 text-small-2  mt-1 w-100'>
                                                                <IoPower className='ms-2 float-end'/>
                                                                <span className='text-small-2'>استارت:</span>
                                                                
                                                                &nbsp;
                                                                {
                                                                    vehicle.points[0]?.start ? 'روشن' : 'خاموش'
                                                                }


                                                            </div>
                                                            <div
                                                                className='badge badge-pill badge-dark bg-secondary mt-2 mx-2 text-small-2  mt-1 w-100'>
                                                                <HiStatusOnline className='ms-2 float-end'/>
                                                                <span className='text-small-2'>وضعیت:</span>

                                                                &nbsp;
                                                                {
                                                                    vehicle.points[0]?.online ? 'آنلاین' : 'آفلاین'
                                                                }


                                                            </div>
                                                            <div
                                                                className='badge badge-pill badge-dark bg-secondary mt-2 mx-2 text-small-2  mt-1 w-100'>
                                                                <IoMdClock className='ms-2 float-end'/>
                                                                {
                                                                    vehicle.date
                                                                }
                                                            </div>
                                                            <div
                                                                className='badge badge-pill badge-dark bg-primary mt-2 mx-2 text-small-2  mt-1 w-100 cursor-pointer'
                                                                onClick={

                                                                    () => {
                                                                        setRouteLat(vehicle?.points[0]?.lat);
                                                                        setRouteLng(vehicle?.points[0]?.long);

                                                                        setShowRouteMap(true)
                                                                        /* window.open(`geo:${vehicle?.points[0]?.lat},${vehicle?.points[0]?.long}`)*/
                                                                        /*window.open("http://maps.google.com/maps?saddr=&daddr=" + vehicle.points[0].lat + "," + vehicle.points[0].long + "&external=true")*/
                                                                    }
                                                                }>
                                                                <IoMdMap className='ms-2 float-end'/>
                                                                مسیریابی تا محل خودرو

                                                            </div>

                                                        </Popup>
                                                    </Marker>
                                                )

                                            } else {
                                                return ('')
                                            }

                                        })
                                    }
                                    <TileLayer
                                        attribution='&copy; <a href="http://telcarnet.com">TelCarNet</a> contributors'
                                        url={normal}
                                    />


                                </MapContainer>
                            </div>

                        </div>
                    </div>
                </div>

            </section>

        </React.Fragment>
    );
}

export default Home;